import React from 'react';
import PropTypes from 'prop-types';
import styles from './ImportErrors.module.css';

const ImportErrors = ({ errors, pagination, onPageChange }) => {
  if (!errors || errors.length === 0) return null;

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      onPageChange(newPage);
    }
  };

  return (
    <div className={styles.errorsContainer}>
      <div className={styles.errorsHeader}>
        <h3 className={styles.errorsTitle}>
          Import Errors ({pagination.totalErrors})
        </h3>
        <div className={styles.errorsSummary}>
          Showing {errors.length} of {pagination.totalErrors} errors
        </div>
      </div>

      <div className={styles.errorsTable}>
        <table>
          <thead>
            <tr>
              <th>Row</th>
              <th>Record</th>
              <th>Error</th>
              <th>Required Action</th>
            </tr>
          </thead>
          <tbody>
            {errors.map((error) => (
              <tr key={error.importJobErrorId}>
                <td className={styles.rowNumber}>{error.csvRowNumber}</td>
                <td className={styles.recordInfo}>
                  <div className={styles.recordIdentifier}>
                    {error.recordIdentifier}
                  </div>
                  <div className={styles.recordType}>{error.recordType}</div>
                </td>
                <td className={styles.errorMessage}>{error.errorMessage}</td>
                <td className={styles.requiredAction}>
                  {error.requiredAction}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {pagination.totalPages > 1 && (
        <div className={styles.pagination}>
          <button
            className={`${styles.pageButton} ${pagination.page === 1 ? styles.disabled : ''}`}
            onClick={() => handlePageChange(pagination.page - 1)}
            disabled={pagination.page === 1}
          >
            Previous
          </button>

          <div className={styles.pageInfo}>
            Page {pagination.page} of {pagination.totalPages}
          </div>

          <button
            className={`${styles.pageButton} ${pagination.page === pagination.totalPages ? styles.disabled : ''}`}
            onClick={() => handlePageChange(pagination.page + 1)}
            disabled={pagination.page === pagination.totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

ImportErrors.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      importJobErrorId: PropTypes.string.isRequired,
      recordType: PropTypes.string.isRequired,
      recordIdentifier: PropTypes.string.isRequired,
      errorMessage: PropTypes.string.isRequired,
      requiredAction: PropTypes.string.isRequired,
      csvRowNumber: PropTypes.number.isRequired,
      batchNumber: PropTypes.number.isRequired,
      createdAt: PropTypes.string.isRequired,
    })
  ),
  pagination: PropTypes.shape({
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    totalErrors: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
  }),
  onPageChange: PropTypes.func.isRequired,
};

export default ImportErrors;
